// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatStatus } from 'components/DataTable'
import { ContactDetailsCell } from './Formatters'

const columns = [{
  columnKey: 'contactCode',
  columnHeader: 'Contact Code',
  columnWidth: '14%',
  sortable: true,
}, {
  columnKey: 'contactName',
  columnHeader: 'Contact Name',
  columnWidth: '22%',
  sortable: true,
}, {
  columnKey: 'companyName',
  columnHeader: 'Company Name',
  columnWidth: '24%',
  sortable: true,
}, {
  columnKey: 'email',
  columnHeader: 'Email',
  columnWidth: '24%',
  sortable: true,
}, {
  cellFormatter: ContactDetailsCell,
  columnKey: 'contactId',
  columnHeader: 'Details',
  columnWidth: '60px',
  sortable: false,
}, {
  cellFormatter: FormatStatus,
  columnHeader: 'Status',
  columnKey: 'status',
  columnWidth: '60px',
  sortable: true,
}]

export default columns
